module.exports = __webpack_public_path__ + "img/arrow-right-icon.226cceab.svg";